import { CreateTenantRequestSchema, CreateTenantResponseSchema, CreateTenantUserForProviderSchema, CreateTenantUserResponseSchema, ProviderStatsResponseSchema, ResendTenantInvitationResponseSchema, TenantDeleteResponseSchema, TenantIdParamSchema, TenantResponseSchema, TenantsResponseSchema, TenantUpdateResponseSchema, TenantUsersListResponseSchema, UpdateTenantRequestSchema, } from '../../schemas.js';
/** REST contract for `insight-api/src/routes/provider/tenants/` and `stats.routes.ts`. */
export const providerTenantsContract = {
    getStats: {
        method: 'GET',
        path: '/provider/stats',
        response: ProviderStatsResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to get provider stats',
    },
    list: {
        method: 'GET',
        path: '/provider/tenants',
        response: TenantsResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'tenants',
        errorMessage: 'Failed to get tenants',
    },
    getById: {
        method: 'GET',
        path: '/provider/tenants/:tenantId',
        pathParams: TenantIdParamSchema,
        response: TenantResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'tenant',
        errorMessage: 'Failed to get tenant',
    },
    create: {
        method: 'POST',
        path: '/provider/tenants',
        body: CreateTenantRequestSchema,
        response: CreateTenantResponseSchema,
        responseStyle: 'unwrap-data',
        timeoutMs: 30000,
        errorMessage: 'Failed to create tenant',
    },
    update: {
        method: 'PUT',
        path: '/provider/tenants/:tenantId',
        pathParams: TenantIdParamSchema,
        body: UpdateTenantRequestSchema,
        response: TenantUpdateResponseSchema,
        responseStyle: 'unwrap-data',
        errorMessage: 'Failed to update tenant',
    },
    delete: {
        method: 'DELETE',
        path: '/provider/tenants/:tenantId',
        pathParams: TenantIdParamSchema,
        response: TenantDeleteResponseSchema,
        responseStyle: 'void',
        errorMessage: 'Failed to delete tenant',
    },
    resendInvitation: {
        method: 'POST',
        path: '/provider/tenants/:tenantId/resend-invitation',
        pathParams: TenantIdParamSchema,
        response: ResendTenantInvitationResponseSchema,
        responseStyle: 'void',
        timeoutMs: 30000,
        errorMessage: 'Failed to resend invitation',
    },
    listUsers: {
        method: 'GET',
        path: '/provider/tenants/:tenantId/users',
        pathParams: TenantIdParamSchema,
        response: TenantUsersListResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'users',
        errorMessage: 'Failed to get tenant users',
    },
    createUser: {
        method: 'POST',
        path: '/provider/tenants/:tenantId/users',
        pathParams: TenantIdParamSchema,
        body: CreateTenantUserForProviderSchema,
        response: CreateTenantUserResponseSchema,
        responseStyle: 'unwrap-data-field',
        dataField: 'user',
        timeoutMs: 30000,
        errorMessage: 'Failed to create tenant user',
    },
};
//# sourceMappingURL=provider-tenants.contract.js.map